import React, { Component } from "react";
// import trackingService from "../../services/trackingService";
import GenerateArrayStrings from "../../components/GenerateArrayStrings";
import RelevanceHighlight from "../../components/RelevanceHighlight";
import moment from 'moment';


class PubMedRawValuesDocumentData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: [],
      documentIndex: [],
      collapsed: true,
      appliedFilters: [],
      searchKeyword: "",
      pageSize: "",
      pageNumber: "",
      score: 0,
      wwid: JSON.parse(localStorage.getItem('wwid'))
    };
  }
  componentDidMount() {
    this.setState({
      item: this.props.item,
      documentIndex: this.props.documentIndex,
      appliedFilters: this.props.appliedFilters,
      searchKeyword: this.props.searchKeyword,
      pageSize: this.props.pageSize,
      pageNumber: this.props.pageNumber,
      score: this.props.score,
    });
    // this.wwid = JSON.parse(localStorage.getItem('wwid'));
    // if ((window.location.origin === 'https://predev-ims.jnj.com' ||
    //   window.location.origin === 'http://localhost:3000') && this.wwid === "643039898") {
    //   const script = document.createElement("script");
    //   script.src = "https://content.readcube.com/injectable-button-assets/readcube-button.min.js";
    //   script.async = true;
    //   document.body.appendChild(script);
    // }
  }
  onClickTitle = () => {
    if (this.state.item.downloadUrl) {
      let url = this.state.item.downloadUrl;
      window.open(url);
    }
  };
  handleToggleSelect = (event) => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
    //console.log(this.state.collapsed);
  };
  /* indexData = event => {
    var title = [event.target.getAttribute("data-title")];
    var products = [event.target.getAttribute("data-products")];
    var docnumber = [event.target.getAttribute("data-docnumber")];
    var docversion = [event.target.getAttribute("data-version")];
    var contentsource = [event.target.getAttribute("data-contentsource")];
    var docID = [event.target.getAttribute("data-docid")];
    var docType = [event.target.getAttribute("data-doctype")];
    var docUrl = [event.target.getAttribute("data-docurl")];
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      "View OR Download Document",
      "Direct",
      window.location.href,
      this.state.searchKeyword,
      this.state.appliedFilters,
      title,
      docversion,
      docnumber,
      docID,
      docUrl,
      products,
      docType,
      "View Document",
      "",
      "",
      contentsource,
      this.props.pageNumber,
      this.props.pageSize
    ); 
  };*/
  render() {
    if (this.state.item.approvedDate) {
      moment(this.state.item.approvedDate).format("D-MMM-YYYY");
    }
    if (this.state.item.modifiedDate) {
      moment(this.state.item.modifiedDate).format("D-MMM-YYYY");
    } else {
      moment(this.state.item.lastUpdated).format("D-MMM-YYYY");
    }

    return (
      <div style={{ float: "left" }}>
        <span
          style={{ color: "#1076bc", fontSize: "14px", fontWeight: "bold" }}
        >
          {this.state.documentIndex}.{" "}
        </span>
        <span>
          <div
            id="docdata"
            className="raw-values-data-title  raw-values-doc-title"
            onClick={this.onClickTitle}
            data-title={this.state.item.docTitle}
            data-products={this.state.item.tempJNJDrugs}
            data-docnumber={this.state.item.domain}
            data-contentsource={this.state.item.domain}
            data-docid={this.state.item.searchID}
            data-doctype={this.state.item.docType}
          >
            {this.state.item.title}
          </div>
          <div className="raw-values-data-title">
            {this.state.item.majorTopicsSynonyms && (
              <RelevanceHighlight
                item={this.state.item}
                searchKeyword={this.props.searchKeyword}
              />
            )}
            {!this.state.collapsed ? (
              <div
                title="Collapse Details"
                onClick={this.handleToggleSelect}
                style={{ cursor: "pointer" }}
                className="raw-values-expand-collapse"
              >
                Hide All
              </div>
            ) : (
              <div
                title="Expand Details"
                onClick={this.handleToggleSelect}
                style={{ cursor: "pointer" }}
                className="raw-values-expand-collapse"
              >
                Show All
              </div>
            )}
          </div>
        </span>
        {this.state.collapsed === false && (
         <>
         <div id={`docID-${this.state.documentIndex}`}>
         <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>PMID:&nbsp;</label>
                </b>
 
                <label>{this.state.item.PMID}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Body:&nbsp;</label>
                </b>
 
                <label>{this.state.item.body}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Classified:&nbsp;</label>
                </b>
 
                <label>{this.state.item.classified}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Content Source:&nbsp;</label>
                </b>
 
                <label>{this.state.item.contentSource}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Doi:&nbsp;</label>
                </b>
 
                <label>{this.state.item.doi}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Index Time:&nbsp;</label>
                </b>
 
                <label>{this.state.item.indexTime}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>mpYear:&nbsp;</label>
                </b>
 
                <label>{this.state.item.mpYear}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Publication Date:&nbsp;</label>
                </b>
 
                <label>{this.state.item.publicationDate}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Title:&nbsp;</label>
                </b>
 
                <label>{this.state.item.title}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Authors:&nbsp;</label>
                </b>
                {this.state.item.authors !== undefined &&
                  this.state.item.authors.length > 0 && (
                    <label>
                      {GenerateArrayStrings(this.state.item.authors)}
                    </label>
                  )}
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Filters:&nbsp;</label>
                </b>
                {this.state.item.filters !== undefined &&
                  this.state.item.filters.length > 0 && (
                    <label>
                      {GenerateArrayStrings(this.state.item.filters)}
                    </label>
                  )}
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Major Topics Synonyms:&nbsp;</label>
                </b>
                {this.state.item.majorTopicsSynonyms !== undefined &&
                  this.state.item.majorTopicsSynonyms.length > 0 && (
                    <label>
                      {GenerateArrayStrings(this.state.item.majorTopicsSynonyms)}
                    </label>
                  )}
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Not In Taxonomy:&nbsp;</label>
                </b>
                {this.state.item.notInTaxonomy !== undefined &&
                  this.state.item.notInTaxonomy.length > 0 && (
                    <label>
                      {GenerateArrayStrings(this.state.item.notInTaxonomy)}
                    </label>
                  )}
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Protocol ID:&nbsp;</label>
                </b>
                {this.state.item.protocolID !== undefined &&
                  this.state.item.protocolID.length > 0 && (
                    <label>
                      {GenerateArrayStrings(this.state.item.protocolID)}
                    </label>
                  )}
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label>Title Synonyms:&nbsp;</label>
                </b>
                {this.state.item.titleSynonyms !== undefined &&
                  this.state.item.titleSynonyms.length > 0 && (
                    <label>
                      {GenerateArrayStrings(this.state.item.titleSynonyms)}
                    </label>
                  )}
              </div>
            </div>
            {this.state.item.source !== undefined && <div>
              <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label> Source Location:&nbsp;</label>
                </b>
 
                <label>{this.state.item.source.location}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label> Source Name:&nbsp;</label>
                </b>
 
                <label>{this.state.item.source.name}</label>
              </div>
            </div>
            <div className="PHM-MetaDataProperty">
              <div style={{ display: "block" }}>
                <b>
                  <label> Source Year:&nbsp;</label>
                </b>
 
                <label>{this.state.item.source.year}</label>
              </div>
            </div>
            </div>}
         </div>
         </>
        )}
      </div>
    );
    //console.log(this.state.item);
  }
}
export default PubMedRawValuesDocumentData;
